import { lazyRouteComponent, createRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { clientRoute } from '../route';

export const clientEventsSearchSchema = z.object({
	eventTimestamp: z.string().optional(),
});

export const clientEventsRoute = createRoute({
	path: '/events',
	getParentRoute: () => clientRoute,
	component: lazyRouteComponent(
		() => import('./ClientEventsPage'),
		'ClientEventsPage',
	),
	validateSearch: clientEventsSearchSchema,
});
